import React from "react";

export default function AWS_Rekognition() {
  return (
    <div>
      <h1>What is AWS Rekognition</h1>
      <p>
        Route: <code>/aws/rekognition</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
